export default "__VITE_ASSET__CxLc9ipr__";